import parseISO from 'date-fns/parseISO';
import { ComponentProps } from 'react';
import { TouchableOpacity } from 'react-native';

import { Button } from '../components/Button';
import { Text } from '../components/Text';
import { View } from '../components/View';
import { useI18n } from '../lib/i18n';
import { Color } from '../styles';

export function WorksheetListItem(props: {
  text: string;
  description?: string;
  completedAt?: string;
  onPress: () => void;
  buttonProps?: Partial<ComponentProps<typeof Button>>;
  testID?: string;
}) {
  const { formatDate } = useI18n();

  return (
    <TouchableOpacity
      onPress={props.onPress}
      style={{ paddingVertical: 0 }}
      accessibilityRole="menuitem"
      testID={props.testID}
    >
      <View row style={{ justifyContent: 'space-between' }}>
        <View spacing={4} flex={1}>
          <Text text={props.text} size={17} weight="bold" numberOfLines={2} />
          {props.description ? (
            <Text text={props.description} numberOfLines={1} color={Color.styleGuide.Gray4} />
          ) : null}
          {props.completedAt ? (
            <Text
              text={`Completed ${formatDate(parseISO(props.completedAt), {
                month: 'short',
                day: '2-digit',
              })}`}
              size={15}
              color={Color.styleGuide.Gray3}
            />
          ) : null}
        </View>
        <Button
          alignSelf="center"
          icon="caret-right"
          onPress={props.onPress}
          variant="text"
          accessibilityLabel="Go to item"
          {...props.buttonProps}
        />
      </View>
    </TouchableOpacity>
  );
}
